import React from "react";
import { withTheme } from "styled-components";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Route, Switch } from "react-router-dom";
import { GoogleAnalytics } from "../utils/googleAnalytics";

import {
  Notifications,
  Loading,
  CommonLayout,
  BREAKPOINTS
} from "@onelogin/react-components";
import SecureNotesContent from "./SecureNotesContent";
import UnsupportedBrowser from "./UnsupportedBrowser";
import { clearNotification } from "../actions/notificationsActions";
import userTabLinksSelector from "../selectors/userTabLinksSelector";
import { PUBLIC_URL, WIDE_VIEW_LIMIT } from "../constants/Env";
import { proceedWithUnsupportedBrowser } from "../actions/otherActions";

const goLogout = () => {
  // eventsEmitter.userLogout();
  window.location.replace("/logout"); //TODO: navigation actions?
};

export const AppContent = ({
  notifications,
  loading,
  clearDisplayedNotification,
  myBrowser,
  isNavbarless,
  menus,
  isDeprecatedBrowser,
  proceedUnsupportedBrowser,
  isSupportedBrowser,
  onProceedWithUnsupportedBrowser
}) => {
  if (loading) {
    return <Loading />;
  }

  const nodes =
    !isSupportedBrowser && !proceedUnsupportedBrowser ? (
      <UnsupportedBrowser
        myBrowser={myBrowser}
        onOk={() => onProceedWithUnsupportedBrowser(isDeprecatedBrowser)}
        onCancel={goLogout}
      />
    ) : (
      <Switch>
        <Route path={`${PUBLIC_URL}`} component={SecureNotesContent} />
      </Switch>
    );

  return (
    <>
      {isNavbarless ? (
        <>
          <Notifications
            notifications={notifications}
            clearDisplayedNotification={clearDisplayedNotification}
          />
          {nodes}
        </>
      ) : (
        <CommonLayout
          menus={menus}
          projectRoot="notes2"
          navbarMaxWidth={WIDE_VIEW_LIMIT}
          mobileBreakpoint={parseInt(BREAKPOINTS.PORTAL_MIDDLE, 10)}
          notifications={notifications}
          clearDisplayedNotification={clearDisplayedNotification}
          flatifyMobileMenus
        >
          {nodes}
        </CommonLayout>
      )}
      <GoogleAnalytics />
    </>
  );
};

const mapStateToProps = state => {
  const menus = [
    {
      initials: state.user.initials,
      name: state.user.fullName,
      picture: state.user.profilePicture,
      align: "right",
      links: userTabLinksSelector(state)
    }
  ];

  if (state.user.isAdmin) {
    menus.unshift({
      title: (
        <FormattedMessage id="administration" defaultMessage="Administration" />
      ),
      align: "right",
      href: "/admin"
    });
  }

  return {
    menus,
    notifications: state.notifications.notificationsQueue,
    myBrowser: state.environment.myBrowser,
    isSupportedBrowser: state.environment.isSupportedBrowser,
    isNavbarless: state.environment.isNavbarless,
    isDeprecatedBrowser: state.environment.isDeprecatedBrowser,
    proceedUnsupportedBrowser: state.environment.proceedUnsupportedBrowser,
    loading: state.user.loading || !state.branding.loaded
  };
};

const mapDispatchToProps = dispatch => ({
  clearDisplayedNotification: notificationId => {
    dispatch(clearNotification(notificationId));
  },
  onProceedWithUnsupportedBrowser: isDeprecatedBrowser => {
    dispatch(proceedWithUnsupportedBrowser(isDeprecatedBrowser));
  }
});

export default withTheme(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AppContent)
);
